export const trimAndReplaceWhiteSpaces = (value: string) => value?.trim().replace(/\s+/g, ' ')
